import React from 'react';
import styles from './TriggerStep.module.css';

interface SegmentListStatesProps {
  isLoading: boolean;
  error: Error | null;
  isEmpty: boolean;
}

export const SegmentListStates: React.FC<SegmentListStatesProps> = ({
  isLoading,
  error,
  isEmpty,
}) => {
  if (isLoading) {
    return <div className={styles.loadingState}>Loading segments...</div>;
  }

  if (error) {
    return (
      <div className={styles.errorState}>
        Failed to load segments. Please try again.
      </div>
    );
  }

  if (isEmpty) {
    return (
      <div className={styles.emptyState}>
        No segments available. Create a segment definition first.
      </div>
    );
  }

  return null;
};
